import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, InfinityIcon, StarIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HeroSequence } from './HeroSequence';
import { ArtworkPatch, GuaranteeBadge, GuaranteeStrip, ShopHotspot } from './BannerOverlays';
import { PrescriptionBadge, PrescriptionStrip } from './PrescriptionBadge';
import { heroChips, media } from '../data/product';
export function Hero() {
  return <section id="top" className="border-b border-white/10 bg-ink-950" data-id="element-243" data-mp="128pgza8jqr2z">
      <div className="relative" data-id="element-244" data-mp="xbpch3rchwdz">
        <img src={media.heroBanner} alt="GritVue X1 illuminated work glasses shown with its clear, amber and smoke lenses beside a mechanic wearing them" className="block h-auto w-full" data-id="element-245" data-mp="x8b7rov7lb3d" />

        {/* Blanks the dead nav words baked into the banner so only the header nav reads as navigation */}
        <ArtworkPatch box={{
        left: '27.2%',
        top: '0%',
        width: '26.8%',
        height: '9.9%'
      }} data-id="element-246" data-mp="381xm10gpl6b8" />

        <GuaranteeBadge box={{
        left: '16.9%',
        top: '56.4%',
        width: '16.6%',
        height: '10%'
      }} data-id="element-247" data-mp="3j8sdtwfflbnq" />
        <ShopHotspot box={{
        left: '3.3%',
        top: '57.4%',
        width: '13.9%',
        height: '8.2%'
      }} data-id="element-248" data-mp="3o7lv7zxu9mt6" />
      </div>

      <GuaranteeStrip data-id="element-249" data-mp="39al9qe68qo35" />
      <PrescriptionStrip data-id="element-250" data-mp="39b4knaxh4c7o" />

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-10 sm:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:px-8 lg:py-16" data-id="element-251" data-mp="399thndbur8hm">
        <div data-id="element-252" data-mp="30hhp9lx6haz0">
          <p className="text-[11px] font-bold uppercase tracking-[0.3em] text-grit-500" data-id="element-253" data-mp="30hreh7aefe3n">GritVue X1™</p>
          <h1 className="grit-headline mt-4 text-[clamp(2.75rem,10vw,5.75rem)] font-extrabold uppercase text-offwhite" data-id="element-254" data-mp="359t19n570n7x">
            America&apos;s work gear
            <br data-id="element-255" data-mp="2qi0nvgoylj8u" />
            <span className="text-grit-500" data-id="element-256" data-mp="2viojkfo4uo9e">just evolved.</span>
          </h1>

          <p className="mt-5 max-w-xl border-l-4 border-grit-500 pl-4 font-display text-2xl font-bold uppercase leading-tight text-offwhite sm:text-3xl" data-id="element-257" data-mp="2vglpnkjv0aze">
            Built for the people who keep America moving.
          </p>

          <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-steel-300 sm:text-base" data-id="element-258" data-mp="s2jp22e1eam5">
            GRITVUE X1™ puts hands-free light, 3 interchangeable lenses, and all-day comfort right where you need
            it, so you can see clearly, work longer, and keep the job moving.
          </p>

          <div className="mt-8" data-id="element-259" data-mp="ddwwgyzefmcz">
            <p className="mb-4 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-260" data-mp="deq92gl1h631">
              <span className="bg-grit-500 px-2.5 py-1 font-display text-xl font-extrabold uppercase leading-none text-ink-950" data-id="element-261" data-mp="1azulzgc74ryf">
                60% off
              </span>
              <span className="font-display text-xl text-steel-500 line-through" data-id="element-262" data-mp="1126pakv15adm">$124.95</span>
              <span className="font-display text-4xl font-extrabold leading-none text-offwhite" data-id="element-263" data-mp="x1ecxiqv2pd4">$49.95</span>
            </p>
            <CtaButton className="w-full sm:w-auto" data-id="element-264" data-mp="3lu0454qihb1b">Upgrade your gear</CtaButton>
            <p className="mt-3 font-display text-xl font-extrabold uppercase tracking-wide text-grit-500 sm:text-2xl" data-id="element-265" data-mp="3hqu083qvfvy0">
              Your old work glasses can&apos;t do this.
            </p>

            <Link to="/legal/guarantee" className="mt-5 block border-2 gold-edge bg-[#1a1408] transition-colors duration-150 ease-grit hover:bg-[#241b0b] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#f2c94c]" data-id="element-266" data-mp="21amuv6fipmkr">
              <p className="gold-plate px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.24em] text-ink-950" data-id="element-267" data-mp="2b2soeklf4c22">
                The GritVue lifetime promise
              </p>
              <div className="flex items-start gap-4 p-4 sm:p-5" data-id="element-268" data-mp="2kxc9vyqpbxmp">
                <InfinityIcon className="mt-0.5 h-9 w-9 shrink-0 text-[#f2c94c]" aria-hidden="true" data-id="element-269" data-mp="2p08vlybjg9uv" />
                <p data-id="element-270" data-mp="2tztrfzvew23d">
                  <span className="grit-headline block text-3xl font-extrabold uppercase gold-text sm:text-4xl" data-id="element-271" data-mp="2tz1x0sdjwaeo">
                    Lifetime free replacement
                  </span>
                  <span className="mt-1.5 block text-[15px] font-semibold text-steel-200" data-id="element-272" data-mp="zmltw0g1xce1">
                    Break it and we replace it. Free. Forever. You never buy work glasses or a headlamp again.
                    Included with every multi-pack.
                  </span>
                </p>
              </div>
            </Link>

            <PrescriptionBadge className="mt-4" data-id="element-273" data-mp="e7h9vgql5sqc" />
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-274" data-mp="9bs7z6r3fzqv">
            <span className="flex items-center gap-1" aria-hidden="true" data-id="element-275" data-mp="3hpqyvtz7kuxi">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-grit-500 text-grit-500" data-id="element-276" data-mp="3csihvwpsqwxu" />)}
            </span>
            <span className="text-sm font-bold uppercase tracking-wide text-offwhite" data-id="element-277" data-mp="3rhenln4drxva">4.9/5</span>
            <span className="text-sm text-steel-400" data-id="element-278" data-mp="3mnshyewmwu8z">18,412 verified reviews · 50,000+ shipped across America</span>
          </div>

          <ul className="mt-8 grid grid-cols-1 gap-x-6 gap-y-2.5 border-t border-white/10 pt-6 sm:grid-cols-2" data-id="element-279" data-mp="2u0ppo4ijxfr6">
            {heroChips.map(chip => <li key={chip} className="flex items-center gap-2.5 text-[15px] font-medium text-steel-200" data-id="element-280" data-mp="19hvpcxf8d5ci">
                <CheckIcon className="h-4 w-4 shrink-0 text-grit-500" aria-hidden="true" data-id="element-281" data-mp="1eayix5k0cesp" />
                {chip}
              </li>)}
          </ul>
        </div>

        <HeroSequence data-id="element-282" data-mp="14km1hm7hp1qs" />
      </div>
    </section>;
}